// This file is used for general use uncategorized utilities
//

/** A promise that resolves after the given duration */
export const sleep = (durationMs: number) =>
  new Promise((resolve) => setTimeout(resolve, durationMs));
